import { IAppState } from '../common/state';

export function selectSource(state: IAppState): string | undefined {
  return state.source;
}
